/**
 * Synthetic permission code the backend adds to a user's organisation permissions when the client restricts
 * open-ended responses (comments, keywords, thematics and related counts) to System Admin/Support, and the user is
 * neither. The backend applies the exemptions, so its presence alone means the user is restricted.
 */
export const OPEN_ENDED_RESPONSES_RESTRICTED = 'OPEN_ENDED_RESPONSES_RESTRICTED';

export const isOpenEndedRestrictedFor = (grantedPermissions: string[] | null | undefined): boolean =>
  !!grantedPermissions && grantedPermissions.includes(OPEN_ENDED_RESPONSES_RESTRICTED);
